export const SET_TRIGGERS_TABLE_CRITERIA_KEYS = 'SET_TRIGGERS_TABLE_CRITERIA_KEYS';

export const setTriggersTableCriteriaKeys = criteriaKeys => {
  return {
    type: SET_TRIGGERS_TABLE_CRITERIA_KEYS,
    data: criteriaKeys,
  };
};
